import httpClient from "Api/httpClient";

const END_POINT = "/api_keys";

const getApiKeys = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getApiKey = (api_keys_id) => {
    if (!api_keys_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + api_keys_id;
    return httpClient.get(SINGLE_END_POINT);
};

const getApiKeyHistory = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    const SINGLE_END_POINT = "/api_rest_logs";
    return httpClient.get(SINGLE_END_POINT, { params: body });
};
const getApiKeyHistoryParams = (api_keys_history_id) => {
    if (!api_keys_history_id) return;
    const SINGLE_END_POINT = "/api_rest_logs/" + api_keys_history_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printApiKey = (api_keys_id) => {
    if (!api_keys_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?api_keys_id=" + api_keys_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createApiKeys = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateApiKeys = (payload, api_keys_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + api_keys_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteApiKeys = (api_keys_id) => {
    const DELETE_END_POINT = END_POINT + "/" + api_keys_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const regenerateApiKey = (api_keys_id, body) => {
    const SINGLE_END_POINT = END_POINT + "/rekey/" + api_keys_id;
    return httpClient.patch(SINGLE_END_POINT, body);
};

export { getApiKeys, getApiKey, printApiKey, createApiKeys, updateApiKeys, deleteApiKeys, getApiKeyHistory, getApiKeyHistoryParams, regenerateApiKey };
